'use client';

import { useEffect, useRef, useState } from 'react';
import { getTagsDomain, getTagsFileUrl } from 'utils/tags';

// Type predicate: the input must be as wide as what callers pass.
// oxlint-disable-next-line anti-slop/no-unknown-parameters, anti-slop/no-unsafe-dictionary-type
function isObjectWithKey<K extends string>(value: unknown, key: K): value is Record<K, unknown> {
  // Narrows an unparsed value before reading it; the parse happens here.
  // oxlint-disable-next-line anti-slop/no-runtime-typeof
  return value != null && typeof value === 'object' && key in value;
}

export function useHubSpotForm(formId: string, sysId?: string) {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const tagsDomain = getTagsDomain();
  const [tagsUrl, setTagsUrl] = useState('');

  useEffect(() => {
    // oxlint-disable-next-line react/no-deriving-state-in-effects -- needs Date.now() cache buster, only on formId change
    setTagsUrl(`${getTagsFileUrl('chime-com-hubspot')}?formId=${formId}&_=${Date.now()}`);
  }, [formId]);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== tagsDomain) return;
      if (event.source !== iframeRef.current?.contentWindow) return;

      const data: unknown = event.data;

      if (isObjectWithKey(data, 'formHeight')) {
        const height = Number(data.formHeight) + 20;
        if (iframeRef.current) {
          iframeRef.current.style.height = `${height}px`;
        }
      }

      if (isObjectWithKey(data, 'redirectUrl')) {
        window.location.href = String(data.redirectUrl);
      }

      if (isObjectWithKey(data, 'scrollToMessage')) {
        const formContainer = document.querySelector(`#hubspot-iframe-${sysId}`);
        formContainer?.scrollIntoView({ behavior: 'smooth' });
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [tagsDomain, sysId]);

  return { iframeRef, tagsUrl };
}
